import {
  Avatar,
  AvatarFallbackText,
  HStack,
  LinearGradient,
  Pressable,
  ScrollView as GSScrollView,
  Text,
  VStack
} from "@gluestack-ui/themed";
import { SummaryCard } from "@repo/core/components/layout/SummaryCard";
import { SummaryCardVariant } from "@repo/core/components/layout/SummaryCard/types";
import { StatusBar } from "@repo/core/components/layout/StatusBar";

import { LinearGradient as ExpoLinearGradient } from "expo-linear-gradient";
import WayupLogo from "@repo/core/assets/images/wayup-logo-mobile.svg";

import { Shortcuts } from "@repo/core/components/core/Shortcuts";
import { ScrollView } from "@repo/core/components/layout/ScrollView";

import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { RecentProposals } from "@repo/core/screens/Home/sections/RecentProposals";

import { useHomeController } from "./controller";
import { styles } from "./styles";

function Home() {
  const {
    user,
    gradientColors,
    proposalsSummary,
    headerHeight,
    handleGoToProfile,
    SHORTCUTS,
    isMobile,
    headerPaddingTop,
    isWeb,
    isTablet
  } = useHomeController();
  const isDesktopWeb = isWeb && !isMobile && !isTablet;

  return (
    <ScrollView bgColor="$backgroundLight50">
      <StatusBar
        statusBarVariant={StatusBarVariantEnum.DARK}
        barStyle="light-content"
        showCustomStatusBar
      />
      <LinearGradient
        h={headerHeight}
        m="$0"
        px="$2"
        pt={headerPaddingTop}
        // @ts-ignore: "colors" is documented and works but isn't typed for some reason
        colors={gradientColors}
        as={ExpoLinearGradient}
      >
        {!isWeb ? (
          <HStack
            mx="$4"
            mb="$4"
            pt="$2"
            alignItems="center"
            justifyContent={!isMobile ? "center" : "space-between"}
          >
            <HStack
              flex={1}
              alignItems="center"
              justifyContent={isMobile ? "flex-start" : "center"}
            >
              <WayupLogo />
              <Text ml="$2" size="sm" fontWeight={600} color="$textLight100">
                Negócios
              </Text>
            </HStack>
            {isMobile ? (
              <Pressable onPress={handleGoToProfile}>
                <Avatar
                  size="md"
                  borderColor="$borderLight300"
                  borderWidth="$1"
                >
                  <AvatarFallbackText>{user?.name}</AvatarFallbackText>
                </Avatar>
              </Pressable>
            ) : null}
          </HStack>
        ) : null}
        {isDesktopWeb ? (
          <HStack px="$3" w="$full">
            <SummaryCard
              title="Propostas"
              titleIcon="file-circle-check"
              isScrollable={false}
              date={new Date(Date.now())}
              summaries={proposalsSummary}
              variant={SummaryCardVariant.blank}
              width="100%"
            />
          </HStack>
        ) : (
          <GSScrollView
            showsHorizontalScrollIndicator={false}
            w="$full"
            horizontal
            contentContainerStyle={styles.scrollViewContainer}
          >
            <HStack gap="$4">
              <SummaryCard
                title="Propostas"
                titleIcon="file-circle-check"
                isScrollable={false}
                date={new Date(Date.now())}
                summaries={proposalsSummary}
                variant={SummaryCardVariant.blank}
              />

              {/*  <SummaryCard
              title="Vendas"
              titleIcon="dollar-sign"
              date={new Date(Date.now())}
              iconVariant="solid"
              summaries={SUMMARIES}
              unit={SummaryUnit.BRL_CURRENCY}
            /> */}
            </HStack>
          </GSScrollView>
        )}
      </LinearGradient>
      <VStack bgColor="$white" w="$full" alignItems="flex-start">
        {SHORTCUTS.length ? (
          <HStack minHeight="$32" p="$4" w="$full">
            <Shortcuts items={SHORTCUTS} />
          </HStack>
        ) : null}
      </VStack>
      <VStack px="$4" py="$8">
        <RecentProposals />

        {/*  <CanView permissions={PermissionsGroup.sales}>
          {transactions.length ? (
            <>
              <SectionTitle
                title="Transações Recentes"
                onShowAll={handleGoToAllTransactions}
              />
              {transactions?.map((transaction) => (
                <VStack py="$4" key={transaction.date.toString()}>
                  <TransactionGroup
                    items={transaction.transactions}
                    date={transaction.date}
                  />
                </VStack>
              ))}
            </>
          ) : null}
        </CanView> */}
      </VStack>
    </ScrollView>
  );
}
export default Home;
